import { render } from "./KeyForm.vue?vue&type=template&id=b1a5f026&scoped=true"
import script from "./KeyForm.vue?vue&type=script&lang=js"
export * from "./KeyForm.vue?vue&type=script&lang=js"

import "./KeyForm.vue?vue&type=style&index=0&id=b1a5f026&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a5f026"]])

export default __exports__